'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import ReportRecord from 'AdsUI/records/reporting/ReportRecord';
import ReportingDataRecord from 'AdsUI/records/reporting/ReportingDataRecord';
import SequenceEntityRecord from 'AdsUI/records/reporting/SequenceEntityRecord';
import CampaignListDataRecord from '../records/reporting/CampaignListDataRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.SEQUENCE_LIST_FETCH_SUCCEEDED:
      {
        const {
          reports = [],
          totals = {},
          filters
        } = payload;
        return state.set(filters, new CampaignListDataRecord({
          aggregateFunnel: new ReportRecord(totals),
          campaigns: ImmutableMap(reports.map(report => [report.entity.id, ReportingDataRecord({
            entity: new SequenceEntityRecord(report.entity.createdAdSequence),
            report: new ReportRecord(report.report)
          })]))
        }));
      }

    default:
      {
        return state;
      }
  }
});